module.exports = __webpack_public_path__ + "img/SIDEBAR_Tour Abbruch.c24a8a17.svg";